import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {DataTableHeaderCommunicationService} from '@Common/widgets/general/data-table';
import {HeaderFilterService} from '@Common/widgets/general/data-table/services/header-filter.service';
import {FilterDateDepositsData} from './filter-date-depostifs.model';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-filter-date-deposits',
  templateUrl: './filter-date-deposits.component.html',
  styleUrls: ['./filter-date-deposits.component.scss', '../filter-deposits.component.scss']
})
export class FilterDateDepositsComponent extends HeaderFilterService implements OnInit {
  public date_filter;
  name: string;
  constructor(@Inject(LOCALE_ID) private locale: string,
              public dtCommunicationSvc: DataTableHeaderCommunicationService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    if (this.data) {
      // dd/mm/yyyy => yyyy-mm-dd
      const _datePicker = this.data.split('/');
      this.date_filter = `${_datePicker[2]}-${_datePicker[1]}-${_datePicker[0]}`;
    }
  }

  onCancel(event) {
  }

  onValidate(event) {
    const _date = formatDate(this.date_filter, 'dd/MM/yyyy', this.locale);
    const dataEmit = <FilterDateDepositsData> {
      nameComponent: this.name,
      action: 'validate',
      value: _date,
      condition: this.date_filter ? `sur ${_date}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }

  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    this.date_filter = null;
    const dataEmit = <FilterDateDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }
}
